import { render, staticRenderFns } from "./app.vue?vue&type=template&id=ea805cd2&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea805cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sacha\\dotnet\\ChoupsBooking\\src\\Satrabel.ChoupsBooking\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ea805cd2', component.options)
    } else {
      api.reload('ea805cd2', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=ea805cd2&scoped=true&", function () {
      api.rerender('ea805cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/calendar/app.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/app.vue
// module id = 326
// module chunks = 2